/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    h3: "h3",
    em: "em",
    strong: "strong"
  }, _provideComponents(), props.components), {Text} = _components;
  if (!Text) _missingMdxReference("Text", true);
  return React.createElement(Text, null, React.createElement(_components.p, null, "Looking for something fun and educational to do after work this week? You’re in luck — there are several technology events taking place this week that could just give you both. Below is a roundup of the events that caught our eye, and you can find a full calendar at ", React.createElement(_components.a, {
    href: "http://www.dctechevents.com/",
    rel: "nofollow noopener noreferrer"
  }, "DC Tech Events"), ". Have a great week!"), React.createElement(_components.h3, {
    id: "monday-august-8"
  }, React.createElement(_components.a, {
    className: "anchor-heading",
    href: "#monday-august-8"
  }, "Monday, August 8")), React.createElement(_components.p, null, React.createElement(_components.em, null, "7:00–9:00 pm")), React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://groups.drupal.org/node/165009",
    rel: "nofollow noopener noreferrer"
  }, React.createElement(_components.strong, null, "Drupal Meetup")), " : Want to talk Drupal with other people using the CMS, or learn what it can do? Come out to this meetup to hear some short presentations related to Drupal and meet developers and others using it."), React.createElement(_components.h3, {
    id: "tuesday-august-9"
  }, React.createElement(_components.a, {
    className: "anchor-heading",
    href: "#tuesday-august-9"
  }, "Tuesday, August 9")), React.createElement(_components.p, null, React.createElement(_components.em, null, "7:00 pm")), React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://www.meetup.com/wordpressdc/events/25629841/",
    rel: "nofollow noopener noreferrer"
  }, React.createElement(_components.strong, null, "Wordpress Meetup")), " : Prefer WordPress to Drupal or want to see how they compare? This meetup will bring together WordPress developers and users for presentations on the true cost of building WordPress sites and on CSS tips and tricks to help you quickly design beautiful sites."), React.createElement(_components.h3, {
    id: "thursday-august-11"
  }, React.createElement(_components.a, {
    className: "anchor-heading",
    href: "#thursday-august-11"
  }, "Thursday, August 11")), React.createElement(_components.p, null, React.createElement(_components.em, null, "7:30 pm")), React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://wiki.hacdc.org/index.php/Electron_Tube_Class",
    rel: "nofollow noopener noreferrer"
  }, React.createElement(_components.strong, null, "HacDC’s Electron Tube Class")), " : Rather hack on more tangible technologies? HacDC is hosting a class on the electron tube, this week talking about fundamental circuits and coupling, splitting circuits, and transformers."), React.createElement(_components.h3, {
    id: "friday-august-12"
  }, React.createElement(_components.a, {
    className: "anchor-heading",
    href: "#friday-august-12"
  }, "Friday, August 12")), React.createElement(_components.p, null, React.createElement(_components.em, null, "6:30 pm")), React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://summerbbq2011.eventbrite.com/",
    rel: "nofollow noopener noreferrer"
  }, React.createElement(_components.strong, null, "Our Summer BBQ")), " : We’re having a BBQ! This Friday we’ll cooking up some half smokes and cracking open some cold beers at the Development Seed garage. Come join us!"), React.createElement(_components.h3, {
    id: "saturday-august-13"
  }, React.createElement(_components.a, {
    className: "anchor-heading",
    href: "#saturday-august-13"
  }, "Saturday, August 13")), React.createElement(_components.p, null, React.createElement(_components.em, null, "6:30–10:00 pm")), React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://www.facebook.com/event.php?eid=167046803365450",
    rel: "nofollow noopener noreferrer"
  }, React.createElement(_components.strong, null, "Nerd Nite")), " : Want to learn something while you drink? Check out Nerd Nite, where people will give presentations on noise experiments, pilotage and aeronautics, and how to read your fortune and future with I Ching while you enjoy a cold drink."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
